import { Component, OnInit, SecurityContext } from '@angular/core';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

import { ThemeService } from '../../core/services/theme.service';

@Component({
  selector: 'app-ssologout',
  templateUrl: './ssologout.component.html',
  styleUrl: './ssologout.component.scss',
  standalone: false
})
export class SsologoutComponent implements OnInit {
  faLock = faLock;

  constructor(
    title: Title,
    public translateService: TranslateService,
    public themeService: ThemeService,
    private sanitizer: DomSanitizer
  ) {
    title.setTitle(
      this.translateService.instant(
        `Logged Out! ${this.themeService.isLightningEnv ? ' - LightUk' : ''}`
      )
    );
  }

  ngOnInit(): void {
    const ssoLogoutUrl = localStorage.getItem('ssoLogoutUrl');
    if (ssoLogoutUrl) {
      localStorage.removeItem('ssoLogoutUrl');
      try {
        const url = new URL(ssoLogoutUrl);
        if (url.protocol === 'https:' || url.protocol === 'http:') {
          const sanitisedUrl = this.sanitizer.sanitize(SecurityContext.URL, url.href);
          if (sanitisedUrl) {
            window.location.href = sanitisedUrl;
          }
        }
      } catch {
        // Invalid URL - do not redirect
      }
    }
  }
}
